import { boolean, date, InferType, number, object, ObjectSchema, string, mixed } from "yup";
import { GerarMovimentacaoObraContract } from "../contracts/gerar-movimentacao-obra.contract";

export const gerarMovimentacaoObraSchema: ObjectSchema<GerarMovimentacaoObraContract> = object({
    idWork: string().nullable().default(null),
    additionalValue: number()
        .typeError("Valor total deve ser um número")
        .transform((value, originalValue) => {
            // Remove máscara e converte para número
            if (typeof originalValue === "string") {
                const cleaned = originalValue.replace(/\./g, "").replace(",", ".").replace(/[^0-9.]/g, "");
                if (!cleaned) return undefined;
                const valorNumber = Number(cleaned);
                return isNaN(valorNumber) ? undefined : valorNumber;
            }
            return value;
        })
        .required("Valor total é obrigatório"),
    newEstimatedEndDate: date().required("Nova data de término estimada é obrigatória"),
    contract: mixed<File>()
        .required("É obrigatório informar um arquivo")
        .test("fileRequired", "É obrigatório informar um arquivo", value => !!value),
    description: string().required("Descrição é obrigatória"),
});


export type GerarMovimentacaoObraFormData = InferType<typeof gerarMovimentacaoObraSchema>;